import React from "react";
import t from "../helpers/i18n";

export default function AlertsLogLink(): React.ReactElement {
  return (
    <a href="/manage/alerts/log/" target="_blank">
      <i className="fa fa-bell mr-2"></i>
      {t("Alarms log", "Журнал аварій", "Журнал аварий", "Dziennik alarmów")}
    </a>
  );
}
